import PageLoader from 'Components/Atoms/Loader/PageLoader/PageLoader';
import EntityCreate from 'Components/Organisms/Entity/EntityCreate/EntityCreate';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import { StoreState } from 'Store/Reducers';
import { fetchEntities } from 'Store/Settings/Entities/Actions';
import { getEntitiesByName, isEntityLoading } from 'Store/Settings/Entities/Selectors';
import { fetchFields } from 'Store/Settings/Fields/Actions';
import { isFieldsLoading } from 'Store/Settings/Fields/Selectors';
import { fetchLayouts } from 'Store/Settings/Layout/Actions';
import { isLayoutLoading } from 'Store/Settings/Layout/Selectors';
import {fetchEntityTypesByEntityId} from 'Store/Settings/EntityTypes/Actions';
import {isEntityTypesFetching} from 'Store/Settings/EntityTypes/Selector';

const EntityCreatePage = ({
    isEntityFetching,
    isFieldsLoading,
    isLayoutsLoading,
    isEntityTypesFetching,
    
    entitiesByName,

    ...props
}: EntityCreatePageProps) => {
    const { entity_name } = useParams<{ entity_name: string }>();

    useEffect(() => {
        props.fetchEntities();
        props.fetchLayouts();
        props.fetchFields();

        const entityId = entitiesByName
            ?.[
            EntityHelper.pluralToSingularEntity(
                EntityHelper.formattedEntityToSystemEntity(
                    entity_name
                )
            )
        ];

        if (entityId) {
            props.fetchEntityTypesByEntityId(entityId);
        }
    }, [entitiesByName]);

    return <PageTemplate>
        {
            !entity_name
            ? <PageLoader description='Id parameter laden...' />
            : isEntityFetching 
            ? <PageLoader description='Entiteiten laden...' />
            : isEntityTypesFetching
            ? <PageLoader description='Entiteit types laden...' />
            : isFieldsLoading
            ? <PageLoader description='Velden laden...' />
            : isLayoutsLoading
            ? <PageLoader description='Layouts laden...' />
            : <>
                <EntityCreate
                    entity_id={
                        entitiesByName
                        ?.[
                            EntityHelper.pluralToSingularEntity(
                                EntityHelper.formattedEntityToSystemEntity(
                                    entity_name
                                )
                            )
                        ]
                    }
                />
            </>
        }
    </PageTemplate>;
}

interface Props {
    children: any
}

const mapState = (state: StoreState) => ({
    entitiesByName: getEntitiesByName(state),

    isEntityFetching: isEntityLoading(state),
    isFieldsLoading: isFieldsLoading(state),
    isLayoutsLoading: isLayoutLoading(state),
    isEntityTypesFetching: isEntityTypesFetching(state)
});

const mapDispatch = {
    fetchEntities,
    fetchLayouts,
    fetchFields,
    fetchEntityTypesByEntityId
};

type EntityCreatePageProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(EntityCreatePage);